import { Scene } from "phaser";
// import { handleMultimedia } from '../../phaser/preload';
import { backStaticAnimation, leftStaticAnimation, mapHandler, reposeAnimation, rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation } from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection } from '../../phaser/update';

// const names = ['jiu', 'sua', 'siyeon', 'handong', 'yoohyeon', 'dami', 'gahyeon'];
const names = ['siyeon', 'yoohyeon'];

let cursors;
let walls;

let characterSelected;
let objNames = {};

export default class Game13 extends Scene {

    constructor() {
        super({ key: "Game13" });
    }
    init(data){
        characterSelected = data.characterSelected;
    }

    preload() {
        cursors = this.input.keyboard.createCursorKeys();
    }
    create() {
        const map = mapHandler(this, 'game13');
        walls = map.walls;

        for(const name of names) {
            objNames[name] = this.physics.add.sprite(500, 500, `${name}-game13`);
            objNames[name].setScale(0.8);
            walkAnimation(this, `${name}-game13`);
            reposeAnimation(this, `${name}-game13`);
            turnStaticAnimation(this, `${name}-game13`);
            upStaticAnimation(this, `${name}-game13`);
            leftStaticAnimation(this, `${name}-game13`);
            rightStaticAnimation(this, `${name}-game13`);
            backStaticAnimation(this, `${name}-game13`);
        
            if(name !== characterSelected) {
                this.physics.add.collider(objNames[name], walls, () => {
                    randomDirection(`${name}-game13`);
                }, null, this);
            } else {
                this.physics.add.collider(objNames[characterSelected], walls);
            }

        }

        for(const name of names) {
            if(name !== characterSelected) {
                this.physics.add.collider(objNames[characterSelected], objNames[name], () => {
                }, null, this);
            }
        }


        this.cameras.main.startFollow(objNames[characterSelected], true);


    }
    update() {
        walkHandler(cursors, objNames[characterSelected], 100, `${characterSelected}-game13`);
        for(const name of names) {
            if(name !== characterSelected) {
                directionHandler(objNames[name], 50, `${name}-game13`);
            }
        }
    }
}